import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import intl from 'react-intl-universal';
import { TaskTimer } from 'tasktimer';
import { Modal, Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Chip from './components/Chip';
import Autocomplete from '@mui/material/Autocomplete';
// components and parts
import MDButton from 'components/MDButton';
import useApi from 'shared/hooks/api';
import localData from 'utils/localData';
import DoCloudDropzone from 'components/DropZone';
import TagCheckboxForm from './components/TagCheckboxForm';
import api from 'utils/api';
import theme from 'assets/theme';
import themeDark from 'assets/theme-dark';
import { PageLoader, PageError, TextEditor } from 'components';
import useStyles from './styles';
import { zIndexValues } from 'utils/styles';
import { useMaterialUIController } from 'context';
import {
  useUploadMissionsContextController,
  addNewMission,
  setMissionStatusContext,
  contextUpdateUploadingSpeed,
} from 'context/NewIssueContext';
import {
  initNewIssue,
  startIssuePeriodicStatusCheck,
  uploadBatchAttachmentsToS3,
  checkForAttachmentsCompletionOnNewIssue,
  getDstOrgOptions,
  getGenderOptions,
  getGenderValue,
  getEmergencyOptions,
  generateConfirmWindowContents,
  getDstOrgObjectById,
  EMERGENCY_STATUS,
} from './utils/utils';

import { calcBatchTotalSize } from 'utils/fileHandling';

import pxToRem from 'assets/theme/functions/pxToRem';
import { formConstants } from './constants/constants';
import { ConfirmModal } from 'shared/modals/confirmModal';
import { getUserFullName } from 'utils/name';
import { DOLPHIN_API } from 'shared/constants/apis';

import BootstrapFormField from 'components/Form/BootstrapFormField';
import AutoCompleteFormField from 'components/Form/AutocompleteFormField';

import { MISSION_CATEGORY } from 'context/constants';
import NewIssueModal from './components/modals/NewIssueModal';
import ExceededLimitModal from './components/modals/ExceededLimitModal';
import ConfirmIssueModal from './components/modals/ConfirmIssueModal';
import SentIssueFailedModal from './components/modals/SentIssueFailedModal';
import { USER_DATA } from 'shared/constants/users';
import logger from 'utils/logger';
import { MISSION_STATUS } from 'shared/constants/uploadAttachments';

const propTypes = {
  parentIssue: PropTypes.object,
  reloadIssue: PropTypes.func,
  close: PropTypes.func,
};

const ISSUE_STATUS_RESPONSE = {
  COMPLETE: 'Complete',
  PROCESS_COMPLETE: 'ProcessComplete',
  FAILED: 'Failed',
};

const log = logger.createLogger('DashboardNew');

const DashboardNew = ({ parentIssue, reloadIssue, close }) => {
  // For new child Issue
  const initPatientName =
    parentIssue === undefined ? '' : parentIssue.patientName;
  const initPatientGender =
    parentIssue === undefined ? '' : parentIssue.patientGender;
  const initDescription =
    parentIssue === undefined ? '' : parentIssue.description;
  const initDepartment =
    parentIssue === undefined ? '' : parentIssue.department;
  const initAttachmentsFromParent =
    parentIssue === undefined
      ? []
      : [
          ...parentIssue.attachmentsOwnedBySrcOrg,
          ...parentIssue.attachmentsOwnedByDstOrg,
        ];
  const initParentIssueId = parentIssue === undefined ? -1 : parentIssue.id;
  const [controllerUploadMissions, dispatchUploadMissions] =
    useUploadMissionsContextController();
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const classes = useStyles;
  const currentOrganization = localData.get(USER_DATA.CURRENT_ORGANIZATION);
  const currentOrganizationId = localData.get(
    USER_DATA.CURRENT_ORGANIZATION_ID
  );

  // states specifically for resetting some Autocomplete inputs;
  const [toggleResetEmergency, setToggleResetEmergency] = useState(false);
  const [toggleResetDstOrgName, setToggleResetDstOrgName] = useState(false);
  const [toggleResetDescription, setToggleResetDescription] = useState(false);
  const [toggleResetPatientGender, setToggleResetPatientGender] =
    useState(false);

  // states related to pre-sending;
  const [exceedUploadMissionsLimit, setExceedUploadMissionsLimit] =
    useState(false);
  const [warnFormIncomplete, setWarnFormIncomplete] = useState(false);
  const [incompleteFields, setIncompleteFields] = useState([]);
  const [showWarningBeforeSend, setShowWarningBeforeSend] = useState(false); // show modal window to confirm sending new Issue;
  const [sendContentsConfirmed, setSendContentsConfirmed] = useState(false); // whether the confirmation checkbox is clicked in above modal window;
  const [newIssueConfirmButtonIsLoading, setNewIssueConfirmButtonIsLoading] =
    useState(false); // whether the 'confirm' button in above modal window is clicked or not;
  const [genderValue, setGenderValue] = useState(
    initPatientGender ? getGenderValue(initPatientGender) : ''
  );

  // for tag system
  const [destinationOrgId, setDestinationOrgId] = useState();
  const [tagList, setTagList] = useState([]);
  const [openCheckboxForm, setOpenCheckboxForm] = useState(false);
  const [selectedTagIds, setSelectedTagIds] = useState([]);

  const [formState, setFormState] = useState({
    patientName: initPatientName,
    patientGender: initPatientGender,
    srcOrgName: currentOrganization,
    srcOrgId: currentOrganizationId,
    dstOrgName: '',
    dstOrgId: '',
    emergency: EMERGENCY_STATUS.REGULAR,
    department: initDepartment,
    doctorInCharge: '',
    description: initDescription,
    file: '',
    dataSet: '',
    doctorsInCharge: [],
    doctorIdsFromSrcOrg: [],
    parentIssueId: initParentIssueId,
  });

  const [structuredAttachments, setStructuredAttachments] = useState([]);
  // states related to procress of sending new issue;

  const [confirmNotCheck, setconfirmNotCheck] = useState(false);
  const [sendNewIssueFailed, setSendNewIssueFailed] = useState(false);
  const [doctorsInCharge, setDoctorsInCharge] = useState([]);
  const [doctorsInChargeTextInputValue, setDoctorsInChargeTextInputValue] =
    useState('');
  const [doctorsInChargeInputFocused, setDoctorsInChargeInputFocused] =
    useState(false);

  // For child issue
  const [attachmentsFromParent, setAttachmentsFromParent] = useState(
    initAttachmentsFromParent
  );

  useEffect(() => {
    //! Needed so dropzone can show the attachments from parent
    setStructuredAttachments(
      attachmentsFromParent.map((item) => item.structureJson)
    );
  }, []);

  useEffect(() => {
    const id = controllerUploadMissions.newIssueIdentifierId;
    if (id in controllerUploadMissions.missions) {
      const { status, missionCategory } = controllerUploadMissions.missions[id];
      if (missionCategory === MISSION_CATEGORY.SEIMITSU && status === 'INIT') {
        resetForm();
        const missionId = controllerUploadMissions.newIssueIdentifierId;
        const mission = controllerUploadMissions.missions[missionId];
        sendNewIssueContinued(mission);
      }
    }
  }, [controllerUploadMissions.newIssueIdentifierId]);

  useEffect(() => {
    const fetchTagsForDestination = async () => {
      // Check if destinationOrgId is a valid ID (number or can be parsed to number)
      if (destinationOrgId && !isNaN(Number(destinationOrgId))) {
        try {
          const response = await api.get(DOLPHIN_API.TAGS, {
            params: {
              organizationId: currentOrganizationId,
              srcOrgId: currentOrganizationId,
              dstOrgId: destinationOrgId,
            },
          });
          if (response.message === 'success') {
            setTagList(response.tags);
          } else {
            log.error('Failed to fetch tags for destination organization');
          }
        } catch (error) {
          log.error('Error fetching tags:', error);
        }
      } else {
        setTagList([]);
      }
    };

    fetchTagsForDestination();
  }, [destinationOrgId, currentOrganizationId]);

  const [{ data, error }] = useApi.useGet(DOLPHIN_API.ORGANIZATION_NEW, {
    params: { organizationId: currentOrganizationId },
  });

  if (!data) return <PageLoader />;
  if (error)
    return (
      <PageError
        errorCode={error.response.status}
        customErrorMessage={error.response.data.message}
        customErrorDescription={error.response.data.description}
      />
    );

  const { dstOrgs, doctorsFromSrcOrg } = data;
  const doctorOptions = doctorsFromSrcOrg.map((doctor) => ({
    label: getUserFullName(doctor.firstName, doctor.lastName),
    id: doctor.id,
  }));

  dstOrgs.sort((a, b) => {
    return a.name < b.name ? -1 : 1;
  });

  const resetForm = () => {
    setFormState({
      patientName: '',
      patientGender: initPatientGender,
      srcOrgName: currentOrganization,
      srcOrgId: currentOrganizationId,
      dstOrgName: formState.dstOrgName,
      dstOrgId: formState.dstOrgId,
      emergency: formState.emergency,
      department: '',
      doctorInCharge: '',
      studyID: '',
      bodyPart: '',
      modality: '',
      description: '',
      file: '',
      dataSet: '',
      doctorsInCharge: [],
      doctorIdsFromSrcOrg: [],
      parentIssueId: -1,
    });
    setDoctorsInCharge([]);

    setGenderValue(initPatientGender);
    setToggleResetEmergency(!toggleResetEmergency);
    setToggleResetPatientGender(!toggleResetPatientGender);
    setToggleResetDstOrgName(!toggleResetDstOrgName);
    setToggleResetDescription(!toggleResetDescription);

    setStructuredAttachments([]);

    // for child issue
    setAttachmentsFromParent([]);
    setDestinationOrgId(formState.dstOrgId);

    if (close !== null && close !== undefined) {
      close();
    }
  };

  // Handle changes from destOrgId
  const handleChangeOnForm = (key, value) => {
    const newFormState = {
      ...formState,
      [key]: value && value.value ? value.value : '',
    };
    // special case

    if (key === formConstants.DEST_ORG_ID) {
      if (value && value.value) {
        const dstOrg = getDstOrgObjectById(value.value, dstOrgs);
        newFormState.dstOrgName = dstOrg.name.toString();
        setDestinationOrgId(value.value);
      } else if (value === null) {
        setDestinationOrgId(null);
      }
    }

    setFormState({ ...newFormState });
  };

  const handleChange = (key) => async (event) => {
    const newFormState = { ...formState, [key]: event.target.value };
    setFormState({ ...newFormState });
  };

  const handleChangeDoctors = (newDoctors) => {
    const doctorIds = newDoctors
      .filter((doctor) => doctor.id !== -1)
      .map((doctor) => doctor.id);
    const doctorNames = newDoctors.map((doctor) => doctor.label);
    setFormState((prevFormState) => ({
      ...prevFormState,
      doctorsInCharge: doctorNames,
      doctorIdsFromSrcOrg: doctorIds,
    }));
  };

  const handleDescriptionChange = (htmlValue) => {
    setFormState((prevFormState) => ({
      ...prevFormState,
      description: htmlValue,
    }));
  };

  const renderSelectedTagsChips = () => {
    const languageCode = localData.get(USER_DATA.PREFFERED_LANGUAGE);
    const result = selectedTagIds.map((tagId, index) => {
      const tag = tagList.find((tag) => tag.id === tagId);
      const labelText =
        tag.displayName[languageCode] ||
        tag.displayName['en-US'] ||
        Object.values(tag.displayName)[0];

      return (
        <Chip
          data-testid="new-issue-tags-selected-chip"
          key={index}
          label={labelText}
          labelcolor={darkMode ? 'white' : 'black'}
          variant="outlined"
          style={{ marginRight: '4px' }}
        />
      );
    });
    return result;
  };

  const checkIfFormCompleted = () => {
    let incompleteFields = [];

    if (!formState.dstOrgId) {
      incompleteFields.push(intl.get('new_label_send_to'));
    }
    if (!formState.emergency) {
      incompleteFields.push(intl.get('new_label_emergency'));
    }
    if (selectedTagIds.length === 0) {
      incompleteFields.push(intl.get('new_label_check_item'));
    }
    if (incompleteFields.length > 0) {
      setIncompleteFields(incompleteFields);
      return false;
    } else {
      return true;
    }
  };

  const handleConfirmContentsCheckbox = () => {
    if (sendContentsConfirmed) {
      setSendContentsConfirmed(false);
    } else {
      setSendContentsConfirmed(true);
    }
  };

  const handleSubmitClick = async (event) => {
    event.preventDefault();
    if (checkIfFormCompleted()) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      setShowWarningBeforeSend(true); // open the "confirm to send issue" modal window
      return;
    } else {
      setWarnFormIncomplete(true);
      return;
    }
  };

  const handleShowWarningBeforeSendModalClose = () => {
    setSendContentsConfirmed(false); // resume default value
    setShowWarningBeforeSend(false); // resume default value
  };

  const handleConfirmNotCheckModalClose = () => {
    setconfirmNotCheck(false);
  };

  const handleNewIssueFailModalClose = () => {
    setNewIssueConfirmButtonIsLoading(false);
    setShowWarningBeforeSend(false);
    setSendContentsConfirmed(false);
    setSendNewIssueFailed(false);
  };

  const handleExceedUploadMissionsLimitClose = () => {
    setExceedUploadMissionsLimit(false);
  };

  const getNumOngoingUploads = () => {
    const ongoings = Object.values(controllerUploadMissions.missions).filter(
      (x) =>
        x.status === MISSION_STATUS.UPLOADING ||
        x.status === MISSION_STATUS.PROCESSING
    );
    return ongoings.length;
  };

  const sendNewIssue = async () => {
    if (!sendContentsConfirmed) {
      setconfirmNotCheck(true);
      return false;
    }

    // Step 0: check if there are already 3 ongoing uploads missions;
    if (getNumOngoingUploads() >= 3) {
      setExceedUploadMissionsLimit(true);
      return;
    }

    setNewIssueConfirmButtonIsLoading(true);

    // Step 0.5: Sort out attachments for New Issue
    //! Remove all the attachments that are not in the parent issue
    const remainingAttachmentsFromParent = attachmentsFromParent.filter(
      (parentAttachment) =>
        structuredAttachments.some(
          (attachment) =>
            attachment.name === parentAttachment.structureJson.name
        )
    );
    //! Remove duplicates attachments
    const uniqueAttachments = structuredAttachments.filter(
      (attachment) =>
        !remainingAttachmentsFromParent.some(
          (parentAttachment) =>
            parentAttachment.structureJson.name === attachment.name
        )
    );

    // Step 1: Create the Issue Entity in the backend, and get the issue unique ID;
    let issueInfo;
    try {
      issueInfo = await initNewIssue(
        formState,
        remainingAttachmentsFromParent,
        uniqueAttachments,
        selectedTagIds
      );
    } catch (error) {
      resetForm();
      setSendNewIssueFailed(true);
      log.error('Error in sendNewIssue', { error });
      return false;
    }

    const { issueId, issueIdentifierId, issueCreatedAt } = issueInfo;

    // Add the upload mission to Context;
    const batchTotalBytes = calcBatchTotalSize(structuredAttachments);

    addNewMission(dispatchUploadMissions, {
      issueId,
      issueIdentifierId,
      issueCreatedAt,
      formState,
      structuredAttachments,
      batchTotalBytes,
      selectedTagIds,
      tagList,
    });

    setNewIssueConfirmButtonIsLoading(false);
    setShowWarningBeforeSend(false);
    setSendContentsConfirmed(false);
    // The rest of the steps are in function "sendNewIssueContinued"
    // It has to wait for addNewMission to finish updating the state stored in context;
    // Therefore It is placed inside useEffect hook
  };

  const sendNewIssueContinued = async (mission) => {
    // This function is a continuation from the "sendNewIssue" function;
    // It is placed in useEffect hook above and only executed after context state is successfully updated;

    const {
      issueId,
      issueIdentifierId,
      issueCreatedAt,
      formState,
      structuredAttachments,
      batchTotalBytes,
    } = mission;

    // Step 1: start a timer to track the upload speed of the upload mission that is about to start;
    const timer0 = new TaskTimer(1000); // milliseconds
    const task_uploadSpeed_checker = {
      id: 'heartbeat',
      tickInterval: 2, // number of ticks between 2 task runs;
      async callback() {
        // can also be an async function, returning a promise
        contextUpdateUploadingSpeed(dispatchUploadMissions, {
          missionId: issueIdentifierId,
        });
        if (!['INIT', 'UPLOADING'].includes(mission.status)) {
          timer0.stop();
        }
      },
    };
    timer0.add(task_uploadSpeed_checker).start();

    // Step 2: Upload the attachments to S3 bucket, and notify the backend to process it;
    try {
      setMissionStatusContext(dispatchUploadMissions, {
        missionId: issueIdentifierId,
        value: MISSION_STATUS.UPLOADING,
      });

      await uploadBatchAttachmentsToS3({
        missionId: issueIdentifierId,
        issueId,
        issueIdentifierId,
        issueCreatedAt,
        structuredAttachments,
        batchTotalBytes,
        srcOrgId: localData.get(USER_DATA.CURRENT_ORGANIZATION_ID),
        dstOrgId: formState.dstOrgId,
        controllerUploadMissions,
        dispatchUploadMissions,
      });
    } catch (error) {
      if (error.code === MISSION_STATUS.ERR_CANCELED) {
        log.warn(`Upload is aborted: ${error}`);
        setMissionStatusContext(dispatchUploadMissions, {
          missionId: issueIdentifierId,
          value: MISSION_STATUS.UPLOAD_ABORTED,
        });
      } else {
        log.error(`Failed to upload batch of attachments: ${error}`);
        setMissionStatusContext(dispatchUploadMissions, {
          missionId: issueIdentifierId,
          value: MISSION_STATUS.UPLOAD_FAILED,
        });
      }
      return false;
    }

    // ON here the cancel modal should be closed if opened
    setMissionStatusContext(dispatchUploadMissions, {
      missionId: issueIdentifierId,
      value: MISSION_STATUS.PROCESSING,
    });

    // Step 3: Notify the backend to start a periodic check on this issue;
    await startIssuePeriodicStatusCheck(issueId);

    let isRequestInProgress = false;

    // Step 4: while waiting for backend to process, poll every a few seconds to check for new status;
    const timer = new TaskTimer(2000); // milliseconds
    const task1 = {
      id: 'heartbeat',
      tickInterval: 5, // number of ticks between 2 taskTuns; e.g. run every 5 sec;
      totalRuns: 1440, // times to run; max 2 hour before timeout;
      async callback() {
        if (isRequestInProgress) {
          log.warn('Previous request still in progress, skipping this poll');
          return;
        }

        isRequestInProgress = true;
        // can also be an async function, returning a promise
        try {
          const issueStatusRes = await checkForAttachmentsCompletionOnNewIssue(
            issueId
          );

          if (issueStatusRes === ISSUE_STATUS_RESPONSE.COMPLETE) {
            setMissionStatusContext(dispatchUploadMissions, {
              missionId: issueIdentifierId,
              value: MISSION_STATUS.PROCESS_COMPLETE,
            });
            timer.stop();
            if (reloadIssue) {
              reloadIssue();
            }
          }
          //! TODO Check this place
          if (issueStatusRes === ISSUE_STATUS_RESPONSE.FAILED) {
            setMissionStatusContext(dispatchUploadMissions, {
              missionId: issueIdentifierId,
              value: MISSION_STATUS.PROCESS_FAILED,
            });
            timer.stop();
          }
        } catch (error) {
          // On error, increase interval to reduce load
          if (error.response?.status === 504) {
            task1.tickInterval = Math.min(task1.tickInterval * 2, 60); // Max 60 seconds
            log.warn(
              'Gateway timeout, increasing poll interval to',
              task1.tickInterval
            );
          }
        } finally {
          isRequestInProgress = false;
        }
      },
    };
    timer.add(task1).start();
  };

  return (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <div data-testid="page-width-control">
        <Grid
          data-testid="page-new-main"
          spacing={3}
          container
          style={{
            paddingLeft: 30,
            marginTop: 30,
            paddingRight: 30,
          }}>
          <Grid size={4}>
            {/* Left side grid*/}
            <Grid container spacing={3}>
              <Grid size={12}>
                <Typography variant="h3">
                  {intl.get('new_text_new_task')}
                </Typography>
              </Grid>
              <Grid size={12} style={{ marginTop: 105 }}>
                <BootstrapFormField
                  data-testid="new-issue-patient-name"
                  id="patientName"
                  label={intl.get('new_label_patient_name')}
                  onChange={handleChange(formConstants.PATIENT_NAME)}
                  value={formState.patientName}
                  //! TODO Add text here
                  // helperText={'This is a helper text'}
                  required
                />
              </Grid>
              <Grid size={12} style={{ marginTop: 10 }}>
                <MDButton
                  data-testid="new-issue-tags-button"
                  color="tertiary"
                  width="50%"
                  disabled={!destinationOrgId}
                  onClick={() => setOpenCheckboxForm(!openCheckboxForm)}
                  style={{
                    color: 'white',
                    fontSize: pxToRem(14),
                    borderRadius: '30px',
                  }}>
                  {intl.get('new_button_modal_tag')}
                </MDButton>
              </Grid>
              <Grid size={12}>{renderSelectedTagsChips()}</Grid>
            </Grid>
          </Grid>
          <Grid size={8}>
            {/* Right side grid */}
            <Grid container spacing={3}>
              <Grid size={12}>
                <Autocomplete
                  data-testid="new-issue-select-destination"
                  id="dstOrgName"
                  onChange={(_, newValue) => {
                    if (newValue.label !== formState.dstOrgName) {
                      setSelectedTagIds([]);
                    }
                    handleChangeOnForm(formConstants.DEST_ORG_ID, newValue);
                  }}
                  value={formState.dstOrgName}
                  options={getDstOrgOptions(dstOrgs)}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value.label
                  }
                  slotProps={{
                    popper: {
                      sx: {
                        zIndex: zIndexValues.modal4 + 1,
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <AutoCompleteFormField
                      {...params}
                      label={intl.get('new_label_send_to')}
                      placeholder={intl.get('new_helper_send_to')}
                      InputLabelProps={{ shrink: true }}
                      required
                    />
                  )}
                  key={toggleResetDstOrgName}
                />
              </Grid>
              <Grid size={12}>
                <Autocomplete
                  data-testid="new-issue-select-emergency"
                  id="emergency"
                  defaultValue={getEmergencyOptions().find(
                    (option) => option.value === formState.emergency
                  )}
                  onChange={(_, newValue) => {
                    handleChangeOnForm(formConstants.EMERGENCY, newValue);
                  }}
                  options={getEmergencyOptions()}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value.label
                  }
                  slotProps={{
                    popper: {
                      sx: {
                        zIndex: zIndexValues.modal4 + 1,
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <AutoCompleteFormField
                      {...params}
                      label={intl.get('new_label_emergency')}
                      placeholder={intl.get('new_helper_emergency')}
                      InputLabelProps={{ shrink: true }}
                      required
                    />
                  )}
                  key={toggleResetEmergency}
                />
              </Grid>
              <Grid size={4}>
                <Autocomplete
                  id="patientGender"
                  data-testid="new-issue-select-patient-gender"
                  value={genderValue}
                  onChange={(_, newValue) => {
                    handleChangeOnForm(formConstants.PATIENT_GENDER, newValue);
                    setGenderValue(
                      newValue && newValue.value
                        ? getGenderValue(newValue.value)
                        : ''
                    );
                  }}
                  options={getGenderOptions()}
                  isOptionEqualToValue={(option, value) => {
                    return value === '' || option.label === value;
                  }}
                  slotProps={{
                    popper: {
                      sx: {
                        zIndex: zIndexValues.modal4 + 1,
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <AutoCompleteFormField
                      {...params}
                      label={intl.get('new_label_patient_gender')}
                      placeholder={intl.get('new_helper_select_gender')}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  key={toggleResetPatientGender}
                />
              </Grid>
              <Grid size={4}>
                <BootstrapFormField
                  data-testid="new-issue-department"
                  id="departmentId"
                  label={intl.get('new_label_department')}
                  onChange={handleChange(formConstants.DEPARTMENT)}
                  value={formState.department}
                />
              </Grid>
              <Grid size={4}>
                <Autocomplete
                  data-testid="new-issue-select-doctor-in-charge"
                  multiple
                  id="doctor-in-charge"
                  onFocus={() => setDoctorsInChargeInputFocused(true)}
                  onBlur={() => setDoctorsInChargeInputFocused(false)}
                  options={doctorOptions}
                  slotProps={{
                    popper: {
                      sx: {
                        zIndex: zIndexValues.modal4 + 1,
                      },
                    },
                  }}
                  open={
                    doctorsInChargeInputFocused &&
                    doctorOptions.some((option) =>
                      option.label
                        .toLowerCase()
                        .includes(doctorsInChargeTextInputValue.toLowerCase())
                    )
                  }
                  onInputChange={(event, value) => {
                    setDoctorsInChargeTextInputValue(value); // Update the input value state
                  }}
                  filterOptions={(opts, state) =>
                    opts.filter((option) =>
                      option.label
                        .toLowerCase()
                        .includes(state.inputValue.toLowerCase())
                    )
                  }
                  value={doctorsInCharge}
                  isOptionEqualToValue={(option, value) =>
                    option.label === value.label
                  }
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                      const tagProps = getTagProps({ index });
                      const { key, ...otherProps } = tagProps;
                      return (
                        <Chip
                          key={key}
                          variant="outlined"
                          labelcolor={darkMode ? 'white' : 'grey'}
                          deleteiconcolor={darkMode ? 'white' : 'grey'}
                          label={option.label}
                          {...otherProps}
                        />
                      );
                    })
                  }
                  renderInput={(params) => (
                    <AutoCompleteFormField
                      {...params}
                      id="doctor-in-charge-input"
                      label={intl.get('new_label_doctor_in_charge')}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  onChange={(_, newValue) => {
                    if (newValue.length > doctorsInCharge.length) {
                      const lastNewValue = newValue[newValue.length - 1];
                      if (typeof lastNewvalue !== 'string') {
                        let i = 0;
                        for (i = 0; i < newValue.length - 1; i++) {
                          if (
                            typeof newValue[i] !== 'string' &&
                            newValue[i].id === lastNewValue.id
                          ) {
                            break;
                          }
                        }
                        if (i !== newValue.length - 1) {
                          newValue.splice(newValue.length - 1);
                          newValue.splice(i, 1);
                        }
                      }
                    }
                    const newDoctors = newValue.map((doctor) => {
                      if (typeof doctor === 'string') {
                        return {
                          label: doctor,
                          id: -1,
                        };
                      }
                      return doctor;
                    });
                    handleChangeDoctors(newDoctors);
                    setDoctorsInCharge(newDoctors);
                  }}
                />
              </Grid>
              <Grid size={12}>
                <Typography
                  style={{
                    fontSize: '12px',
                    marginLeft: '10px',
                    marginTop: 0,
                  }}>
                  {intl.get('new_label_additional_info')}
                </Typography>
                <TextEditor
                  sx={classes.description}
                  placeholder={intl.get('new_label_case_description')}
                  defaultValue={formState.description}
                  onChange={handleDescriptionChange}
                  key={toggleResetDescription}
                />
              </Grid>
            </Grid>
          </Grid>
          {/* Dropzone */}
          <Grid size={12} style={{ marginTop: 30 }}>
            <div style={{ position: 'relative' }}>
              <DoCloudDropzone
                existingStructuredAttachments={[]}
                structuredAttachments={structuredAttachments}
                setStructuredAttachments={setStructuredAttachments}
                darkMode={darkMode}
              />
            </div>
          </Grid>
          <Grid
            size={12}
            style={{
              marginTop: '45px',
              display: 'flex',
              justifyContent: 'center',
            }}>
            <MDButton
              data-testid="new_send_button"
              color="tertiary"
              variant="contained"
              onClick={handleSubmitClick}
              style={{
                fontSize: pxToRem(18),
                minWidth: '300px',
                borderRadius: '30px',
              }}>
              {intl.get('new_button_submit')}
            </MDButton>
          </Grid>
        </Grid>
      </div>

      {/* Modals */}

      <ConfirmModal
        isOpened={warnFormIncomplete}
        title={intl.get('new_modal_text_warning_title')}
        bodyText={intl.get('new_modal_text_warning_text_empty')}
        onConfirm={() => setWarnFormIncomplete(false)}
        confirmButtonText={intl.get('new_modal_tag_confirm')}>
        <Box>
          {incompleteFields &&
            incompleteFields.map((field, index) => (
              <Typography variant="h6" style={{ color: 'red' }} key={index}>
                {field}
              </Typography>
            ))}
          <Typography variant="h6" style={{ paddingTop: '30px' }}>
            {intl.get('new_modal_text_warning_text_fill')}
          </Typography>
        </Box>
      </ConfirmModal>

      {/*//! Different irregular modal - Open the more info modal, where select  */}
      <Modal
        data-testid="new-issue-tags-modal"
        open={openCheckboxForm}
        onClose={() => setOpenCheckboxForm(false)}
        sx={classes.modalModal}>
        <Box>
          <TagCheckboxForm
            tagList={tagList}
            selectedTagIds={selectedTagIds}
            setSelectedTagIds={setSelectedTagIds}
            openCheckboxForm={openCheckboxForm}
            setOpenCheckboxForm={setOpenCheckboxForm}
          />
        </Box>
      </Modal>

      <SentIssueFailedModal
        isOpened={sendNewIssueFailed}
        onConfirm={handleNewIssueFailModalClose}
      />

      <ConfirmIssueModal
        isOpened={confirmNotCheck}
        onConfirm={handleConfirmNotCheckModalClose}
      />

      <ExceededLimitModal
        exceedUploadMissionsLimit={exceedUploadMissionsLimit}
        handleExceedUploadMissionsLimitClose={
          handleExceedUploadMissionsLimitClose
        }
      />

      {/* Modal of confirmation sending new Issue to the server */}
      {/* TODO Pass the mission details to the modal */}
      <NewIssueModal
        showWarningBeforeSend={showWarningBeforeSend}
        sendNewIssue={sendNewIssue}
        handleShowWarningBeforeSendModalClose={
          handleShowWarningBeforeSendModalClose
        }
        newIssueConfirmButtonIsLoading={newIssueConfirmButtonIsLoading}
        windowContents={generateConfirmWindowContents(
          formState,
          structuredAttachments,
          darkMode,
          selectedTagIds,
          tagList
        )}
        darkMode={darkMode}
        handleConfirmContentsCheckbox={handleConfirmContentsCheckbox}
      />
    </ThemeProvider>
  );
};

DashboardNew.propTypes = propTypes;

export default DashboardNew;
